/* Winterfeldt – Filtermenü (snippets/facets.liquid)
   - Auswahl in der Kopfzeile jeder Gruppe live aktualisieren
   - Hersteller-Suche und "Alle anzeigen"
   - Preis-Schnellauswahl
   - Button "N Produkte anzeigen" mit echter Trefferzahl */
(() => {
  if (window.__wfFilter) return;
  window.__wfFilter = true;

  const FORM_ID = 'facets-drawer-form';
  const knopfText = (n) => (n === 0 ? 'Keine Treffer' : n === 1 ? '1 Produkt anzeigen' : n + ' Produkte anzeigen');

  function setzeKnopf(n) {
    document.querySelectorAll('button[type="submit"][form="' + FORM_ID + '"]').forEach((b) => {
      const c = b.querySelector('.button__content') || b;
      if (c.textContent !== knopfText(n)) c.textContent = knopfText(n);
    });
  }

  /* Nur wenn das Filtermenü neu gezeichnet wurde (neues Element), den Startwert setzen */
  let letztes = null;
  function startZahl() {
    const a = document.querySelector('#' + FORM_ID + ' [data-wf-anzahl]');
    if (!a || a === letztes) return;
    letztes = a;
    setzeKnopf(Number(a.dataset.wfAnzahl));
  }

  const preisFelder = (g) => g.querySelectorAll('.wf-f__preisfelder input');

  function wahlText(g) {
    if (g.querySelector('[data-wf-preis]')) {
      const [vi, bi] = preisFelder(g);
      const von = vi ? vi.value.trim() : '';
      const bis = bi ? bi.value.trim() : '';
      if (von && bis) return von + '–' + bis + ' €';
      if (von) return 'ab ' + von + ' €';
      if (bis) return 'bis ' + bis + ' €';
      return '';
    }
    return [...g.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked')]
      .map((i) => { const s = i.parentElement.querySelector('span'); return s ? s.textContent.trim() : ''; })
      .filter(Boolean)
      .join(', ');
  }

  function preisChips(g) {
    const [vi, bi] = preisFelder(g);
    if (!vi || !bi) return;
    g.querySelectorAll('[data-von]').forEach((c) => c.classList.toggle('is-on', c.dataset.von === vi.value.trim() && c.dataset.bis === bi.value.trim()));
  }

  let timer;
  let ctrl;
  function zaehle(form) {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const ff = form.closest('facets-form');
      if (!ff) return;
      const params = new URLSearchParams(new FormData(form));
      ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => { if (params.get(k) === '') params.delete(k); });
      params.set('section_id', ff.getAttribute('section-id'));
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const html = await (await fetch(form.action + '?' + params.toString(), { signal: ctrl.signal })).text();
        const m = html.match(/data-wf-anzahl="(\d+)"/);
        if (m) setzeKnopf(Number(m[1]));
      } catch (e) {}
    }, 250);
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('[data-wf-suche]')) return;
    const g = e.target.closest('[data-wf-gruppe]');
    if (g) {
      if (g.querySelector('[data-wf-preis]')) preisChips(g);
      const w = g.querySelector('[data-wf-wahl]');
      if (w) w.textContent = wahlText(g);
    }
    const form = e.target.closest('form');
    if (form && form.id === FORM_ID) zaehle(form);
  });

  document.addEventListener('input', (e) => {
    const s = e.target.closest('[data-wf-suche]');
    if (!s) return;
    const g = s.closest('[data-wf-gruppe]');
    const q = s.value.trim().toLowerCase();
    g.classList.toggle('is-alle', !!q || g.dataset.alle === '1');
    g.querySelectorAll('.wf-f__zeile').forEach((z) => { z.hidden = !!q && !(z.dataset.wfName || '').includes(q); });
    const m = g.querySelector('[data-wf-mehr]');
    if (m) m.hidden = !!q || g.dataset.alle === '1';
  });

  document.addEventListener('click', (e) => {
    const m = e.target.closest('[data-wf-mehr]');
    if (m) {
      const g = m.closest('[data-wf-gruppe]');
      g.dataset.alle = '1';
      g.classList.add('is-alle');
      m.hidden = true;
      return;
    }
    const c = e.target.closest('[data-wf-preis] [data-von]');
    if (c) {
      e.preventDefault();
      const g = c.closest('[data-wf-gruppe]');
      const [vi, bi] = preisFelder(g);
      if (!vi || !bi) return;
      const war = c.classList.contains('is-on');
      vi.value = war ? '' : c.dataset.von;
      bi.value = war ? '' : c.dataset.bis;
      bi.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wf-suche]')) e.preventDefault();
  });

  let mo;
  new MutationObserver(() => {
    clearTimeout(mo);
    mo = setTimeout(startZahl, 60);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startZahl);
  else startZahl();
})();
